import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AppLayout } from '@/layouts/AppLayout'
import { AuthLayout } from '@/layouts/AuthLayout'
import { RegistrationLayout } from '@/layouts/RegistrationLayout'
import { ProtectedRoute } from '@/auth/ProtectedRoute'
import { AdminRoute } from '@/auth/AdminRoute'
import { isRegistrationEnabled } from '@/config/features'
import { LoginPage } from '@/pages/LoginPage'
import { RegisterPage } from '@/pages/RegisterPage'
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage'
import { VerifyEmailPage } from '@/pages/VerifyEmailPage'
import { CompleteProfilePage } from '@/pages/CompleteProfilePage'
import { GameModePlaceholderPage } from '@/components/GameModePlaceholderPage'
import { SuccessOverviewPage } from '@/pages/SuccessOverviewPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { ProfilePage } from '@/pages/ProfilePage'
import { TrophyCabinetPage } from '@/pages/TrophyCabinetPage'
import { FriendsPage } from '@/pages/FriendsPage'
import { PouleDetailPage } from '@/pages/PouleDetailPage'
import { MatchDetailPage } from '@/pages/MatchDetailPage'
import { MatchChatPage } from '@/pages/MatchChatPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { TeamPage } from '@/pages/TeamPage'
import { ManagerPage } from '@/pages/ManagerPage'
import { ManagerLeaguePage } from '@/pages/ManagerLeaguePage'
import { ManagerRoundPage } from '@/pages/ManagerRoundPage'
import { InvitePage } from '@/pages/InvitePage'
import { AdminSquadBuilderPage } from '@/pages/AdminSquadBuilderPage'
import { PouleCreatePage } from '@/pages/PouleCreatePage'
import { PouleAdminPage } from '@/pages/PouleAdminPage'
import { PouleBillingPage } from '@/pages/PouleBillingPage'
import { OfficialRulesPage } from '@/pages/OfficialRulesPage'
import { FantasyChallengesPage } from '@/pages/FantasyChallengesPage'
import { FantasyChallengePage } from '@/pages/FantasyChallengePage'
import { AdminFantasyChallengeCreatePage } from '@/pages/AdminFantasyChallengeCreatePage'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      { index: true, element: <LoginPage /> },
      { path: 'login', element: <LoginPage /> },
      {
        path: 'registreren',
        element: isRegistrationEnabled ? <RegisterPage /> : <Navigate to="/login" replace />,
      },
      { path: 'wachtwoord-vergeten', element: <ForgotPasswordPage /> },
      { path: 'verifieer-email', element: <VerifyEmailPage /> },
    ],
  },
  {
    path: '/',
    element: <RegistrationLayout />,
    children: [{ path: 'account-aanmaken', element: <CompleteProfilePage /> }],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: 'dashboard', element: <SuccessOverviewPage /> },
          { path: 'dashboard/poules', element: <DashboardPage /> },
          { path: 'dashboard/poules/aanmaken', element: <PouleCreatePage /> },
          { path: 'dashboard/poules/:pouleId/beheer', element: <PouleAdminPage /> },
          // Stripe currently returns to /billing. Keep this alias alongside the
          // Dutch in-app route so existing checkout sessions do not land on 404.
          { path: 'poules/:pouleId/billing', element: <PouleBillingPage /> },
          { path: 'poules/:pouleId/licentie', element: <PouleBillingPage /> },
          { path: 'spelregels/:gameKey', element: <OfficialRulesPage /> },
          { path: 'dashboard/manager', element: <ManagerPage /> },
          { path: 'dashboard/manager/challenges', element: <FantasyChallengesPage /> },
          { path: 'dashboard/manager/challenges/aanmaken', element: <AdminFantasyChallengeCreatePage /> },
          { path: 'dashboard/manager/challenges/:challengeId', element: <FantasyChallengePage /> },
          { path: 'dashboard/manager/competities/:fantasyLeagueId', element: <ManagerLeaguePage /> },
          { path: 'dashboard/manager/competities/:fantasyLeagueId/rondes/:appRoundId', element: <ManagerRoundPage /> },
          {
            path: 'dashboard/trivia',
            element: (
              <GameModePlaceholderPage
                badge="Trivia"
                badgeClassName="bg-amber-500/15 text-amber-300"
                title="Golero Trivia"
                subtitle="Test je kennis en daag je vrienden uit."
              />
            ),
          },
          { path: 'invite/fantasy-subleague/:token', element: <InvitePage kind="manager" /> },
          { path: 'invite/:token', element: <InvitePage /> },
          { path: 'join/:token', element: <InvitePage /> },
          { path: 'poules/:pouleId', element: <PouleDetailPage /> },
          { path: 'poules/:pouleId/wedstrijden/:matchId', element: <MatchDetailPage /> },
          { path: 'wedstrijden/:matchId', element: <MatchDetailPage /> },
          { path: 'wedstrijden/:matchId/chat', element: <MatchChatPage /> },
          { path: 'teams/:teamId', element: <TeamPage /> },
          { path: 'friends', element: <FriendsPage /> },
          { path: 'vrienden', element: <FriendsPage /> },
          { path: 'profiel', element: <ProfilePage /> },
          { path: 'profiel/prijzenkast', element: <TrophyCabinetPage /> },
          {
            element: <AdminRoute />,
            children: [
              { path: 'admin/squad-builder', element: <AdminSquadBuilderPage /> },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
])
